import { render, staticRenderFns } from "./KSwitch.vue?vue&type=template&id=31885446"
import script from "./KSwitch.vue?vue&type=script&lang=js"
export * from "./KSwitch.vue?vue&type=script&lang=js"
import style0 from "./KSwitch.vue?vue&type=style&index=0&id=31885446&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports